import { render, staticRenderFns } from "./CustomToast.vue?vue&type=template&id=5b3a9ba0&scoped=true"
import script from "./CustomToast.vue?vue&type=script&lang=js"
export * from "./CustomToast.vue?vue&type=script&lang=js"
import style0 from "./CustomToast.vue?vue&type=style&index=0&id=5b3a9ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a9ba0",
  null
  
)

export default component.exports